let Home = {
    init() {
        if ($('#worldMapChart').length) {
            this.worldMapChart();
        }
    },

    worldMapChart() {
        Highcharts.mapChart('worldMapChart', {
            accessibility: {
                enabled: false
            },
            chart: {
                map: 'custom/world',
                borderWidth: 0
            },

            title: {
                text: ''
            },

            subtitle: {
                text: ''
            },

            legend: {
                enabled: true
            },
            plotOptions: {
                map: {
                    allAreas: false,
                    joinBy: ['iso-a2', 'code'],
                    dataLabels: {
                        enabled: true,
                        color: '#0000FF',
                        style: {
                            fontWeight: 'bold'
                        },
                        // Only show dataLabels for areas with high label rank
                        format: null,
                        formatter: function () {
                            if (this.point.properties && this.point.properties.labelrank.toString() < 5) {
                                return this.point.properties['iso-a2'];
                            }
                        }
                    },
                    tooltip: {
                        headerFormat: '',
                        pointFormat: '{point.name}: <b>{series.name}</b>'
                    }
                }
            },
            series: [{
                name: 'AEO Programmes - Operational',
                color: '#0381c3',
                // data: ['FJ', 'DZ', 'AO', 'AR', 'AM', 'AU', 'AT', 'AZ', 'BH', 'BD', 'BY', 'BE', 'BO', 'BR', 'BG', 'BI', 'CA', 'CL', 'CN', 'CO', 'CR', 'CI', 'HR', 'CU', 'CY', 'CZ', 'DK', 'DO', 'EC', 'EG', 'SV', 'EE', 'FI', 'FR', 'GE', 'DE', 'GR', 'GT', 'HK', 'HU', 'IS', 'IN', 'ID', 'IR', 'IE', 'IL', 'IT', 'JM', 'JP', 'JO', 'KZ', 'KE', 'KR', 'LV', 'LT', 'LU', 'MW', 'MY', 'MT', 'MU', 'MX', 'MD', 'MN', 'MA', 'NL', 'NZ', 'MK', 'NO', 'OM', 'PA', 'PY', 'PE', 'PH', 'PL', 'PT', 'QA', 'RO', 'RU', 'RW', 'SA', 'RS', 'SG', 'SK', 'SI', 'ES', 'SE', 'CH', 'TH', 'TN', 'TR', 'UG', 'AE', 'GB', 'US', 'UY', 'VN', 'ZW'].map(function (code) {
                data: window.aeo_operational.map(function (code) {
                    return {code: code};
                }),
                dataLabels: {
                    enabled: false,
                    color: '#FFFFFF',
                    formatter: function () {
                        return this.point.name;
                    }
                },
                tooltip: {
                    enabled: true,
                    headerFormat: '',
                    pointFormat: '{point.name}'
                }
            }, {
                name: 'AEO Programmes - Under Development',
                color: '#009d91',
                // data: ['ZA', 'BS', 'BW', 'BF', 'CM', 'KM', 'CD', 'GA', 'GH', 'LS', 'MV', 'MM', 'NA', 'NG', 'PK', 'LK', 'SC', 'BA', 'PG', 'ME'].map(function (code) {
                data: window.aeo_development.map(function (code) {
                    return {code: code};
                }),
                dataLabels: {
                    enabled: false,
                    color: '#FFFFFF',
                    formatter: function () {
                        return this.point.name;
                    }
                },
                tooltip: {
                    enabled: false,
                    headerFormat: '',
                    pointFormat: '{point.name}'
                }
            }, {
                name: '',
                color: '#e0e0e0',
                // data: ['AF', 'AL', 'AD', 'AI', 'AG', 'AW', 'BB', 'BZ', 'BJ', 'BM', 'BT', 'BN', 'KH', 'CV', 'KY', 'CF', 'TD', 'CG', 'CK', 'CW', 'KP', 'DJ', 'DM', 'GQ', 'ER', 'SZ', 'ET', 'GM', 'GI', 'GD', 'GN', 'GW', 'GY', 'HT', 'VA', 'HN', 'IQ', 'KW', 'KG', 'LA', 'LB', 'LR', 'LY', 'LI', 'MO', 'MG', 'ML', 'MR', 'MC', 'MS', 'MZ', 'NP', 'NC', 'NI', 'NE', 'PS', 'PR', 'SH', 'KN', 'LC', 'SM', 'ST', 'SN', 'SL', 'SB', 'SO', 'SS', 'VC', 'SD', 'SR', 'SY', 'TJ', 'TZ', 'TL', 'TG', 'TK', 'TT', 'TM', 'TC', 'UA', 'UZ', 'VU', 'VE', 'WF', 'EH', 'YE', 'ZM'].map(function (code) {
                data: window.aeo_neutral.map(function (code) {
                    return {code: code};
                }),
                showInLegend: false,
                dataLabels: {
                    enabled: false,
                    color: '#000000',
                    formatter: function () {
                        return this.point.name;
                    }
                },
                tooltip: {
                    enabled: true,
                    headerFormat: '',
                    pointFormat: '{point.name}'
                }
            }],
            credits: {
                enabled: false
            }
        });
    },
}

$().ready(() => {
    window.Home = Home;
    window.Home.init();
});

// 'WS' - Samoa
// 'KI' - Kirbati
// 'UM' - United States Minor Outlying Islands
// 'FM' - Federated States of Micronesia
// 'MH' - Marshall Islands
// 'AS' - American Samoa
// 'TO' - Tonga
// 'NR' - Nauru
// 'TV' - Tuvalu
// 'FJ' - Fiji
// 'GU' - Guam
// 'PW' - Palau
// 'MP' - The Northern Mariana Islands
